import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import '@fontsource-variable/inter';
import './index.css';
import { router } from '@/app/router';
import { installChunkReload } from '@/shared/lib/chunk-reload';
import { FullScreenLoader } from '@/features/auth/ProtectedRoute';
import { I18nProvider } from '@/i18n/I18nProvider';
import { queryClient } from '@/shared/lib/queryClient';
import { TooltipProvider } from '@/shared/ui';

installChunkReload();

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <TooltipProvider delayDuration={300}>
          <Suspense fallback={<FullScreenLoader />}>
            <RouterProvider router={router} />
          </Suspense>
        </TooltipProvider>
      </I18nProvider>
    </QueryClientProvider>
  </StrictMode>,
);
